export default {
  getLead: require('./getLead').default,
  getLocalLead: require('./getLocalLead').default,
  saveLead: require('./saveLead').default,
  saveLeadActivate: require('./saveLeadActivate').default,
  acceptTerms: require('./acceptTerms').default,
  grantPermissions: require('./grantPermissions').default,
  savePermissions: require('./savePermissions').default,
  installInStation: require('./installInStation').default,
  privateRouteControl: require('./privateRouteControl').default,
};
